"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.setAppPaneUnderlayVisibility = legacy_1.select({
    store: function () { return store_1.default; },
})(legacy_1.action('setAppPaneUnderlayVisibility')(function setAppPaneUnderlayVisibility(key, isShown, shrinkable, state) {
    if (!isShown) {
        state.store.shrinkable.delete(key);
    }
    else {
        state.store.shrinkable.set(key, shrinkable);
    }
    state.store.isShown.set(key, isShown);
}));
exports.default = exports.setAppPaneUnderlayVisibility;
//# sourceMappingURL=setAppPaneUnderlayVisibility.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-application/lib/actions/setAppPaneUnderlayVisibility.js
// module id = 2818
// module chunks = 3 4 45 98